import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  class: "barra-transicao__link",
  href: "https://www.pontotel.com.br/lp/regularizador-de-escalas-e-jornadas-clientes#formulario",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_3 = { class: "barra-transicao__selo" }
const _hoisted_4 = { class: "barra-transicao__mensagem" }
const _hoisted_5 = { class: "barra-transicao__acao" }
const _hoisted_6 = ["aria-label", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (!$setup.fechada)
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        ref: "barra",
        class: "barra-transicao",
        "aria-label": $setup.t('compartilhados.BarraTransicaoDeEscalas.aviso')
      }, [
        _createElementVNode("a", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", {
              class: "barra-transicao__ponto",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString($setup.t('compartilhados.BarraTransicaoDeEscalas.selo')), 1 /* TEXT */)
          ]),
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("strong", null, _toDisplayString($setup.t('compartilhados.BarraTransicaoDeEscalas.titulo')), 1 /* TEXT */),
            _createElementVNode("span", null, _toDisplayString($setup.t('compartilhados.BarraTransicaoDeEscalas.descricao')), 1 /* TEXT */)
          ]),
          ($setup.diasRestantes > 0)
            ? (_openBlock(), _createBlock(_component_i18n_t, {
                key: 0,
                keypath: "compartilhados.BarraTransicaoDeEscalas.contagem",
                plural: $setup.diasRestantes,
                tag: "span",
                class: "barra-transicao__contagem"
              }, {
                dias: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString($setup.diasRestantes), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["plural"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString($setup.t('compartilhados.BarraTransicaoDeEscalas.prepararTransicao')), 1 /* TEXT */)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "barra-transicao__fechar",
          "aria-label": $setup.t('compartilhados.BarraTransicaoDeEscalas.fechar'),
          title: $setup.t('compartilhados.BarraTransicaoDeEscalas.fechar'),
          onClick: $setup.fechar
        }, [
          _createVNode($setup["IconeSVG"], {
            icone: "icone-fechar",
            cor: "currentColor",
            width: "var(--espacamento-16)",
            height: "var(--espacamento-16)",
            "aria-hidden": "true"
          })
        ], 8 /* PROPS */, _hoisted_6)
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}